import React from "react";
//@mui
import { Box, Typography, useTheme } from "@mui/material";
//components
import Iconify from "~src/components/Iconify";
//types
import { CountryTrafficGrowth } from "~src/types/brand";

export default function ChangeIndicator({
  data,
}: {
  data: CountryTrafficGrowth;
}) {
  const theme = useTheme();
  let iconProps: { icon: string; color: string } = { icon: "", color: "" };
  let icon: React.ReactNode;

  if (data.change === "increase") {
    iconProps = {
      icon: "ph:arrow-up-bold",
      color: theme.palette.success.light,
    };
  } else if (data.change === "decrease") {
    iconProps = {
      icon: "ph:arrow-down-bold",
      color: theme.palette.error.light,
    };
  }

  if (iconProps) {
    icon = (
      <Iconify
        icon={iconProps.icon}
        width={15}
        height={15}
        style={{ color: iconProps.color }}
      />
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        ml: 1,
        alignItems: "center"
      }}>
      {icon}
      <Typography sx={{ color: iconProps?.color }}>{data.growth}</Typography>
    </Box>
  );
}
